<template>
  <!-- 活动管理-推广活动管理-添加奖品弹窗 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="type === 1 ? '添加奖品' : '编辑奖品'"
      width="350px"
      @close="closeDialog"
    >
      <el-form
        :model="dataForm"
        ref="dataForm"
        label-width="100px"
        size="small"
        :rules="replyRules"
      >
        <el-form-item prop="name" label="奖品名称">
          <el-input placeholder="请输入奖品名称" v-model="dataForm.name">
          </el-input>
        </el-form-item>
        <el-form-item prop="img" label="图片">
          <ImgUpload v-model="dataForm.img"></ImgUpload>
        </el-form-item>
        <el-form-item prop="weight" label="权重">
          <el-input placeholder="请输入权重" v-model="dataForm.weight">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import { getCookie } from '@/utils/cookie'
import saveFile from '@/utils/saveFile'
import ImgUpload from '@/components/common/ImgUpload.vue'


export default {
  components: {
    ImgUpload
  },
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//数据
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dataForm: {
        name: '',
        img: '',
        weight: ''
      },
      dataList: undefined,//分组列表
      replyRules: {//回复弹窗规则验证
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.fromInfo) {
        this.dataForm = this.fromInfo
      }
    },
  },
  created() {
  },
  methods: {
    submit() {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      let params = this.dataForm
      if (this.type === 1) {
        postApiData('referee_ranking_prize', params).then(res => {
          if (res.code) {
            this.$message.success(res.message)
            this.$emit('refresh')
            this.closeDialog()
          } else {
            this.$message.error(res.message)
          }
        }).finally(() => {
          this.buttonLoading = false
        })
      } else if (this.type === 2) {
        patchApiData(`referee_ranking_prize/${this.dataForm.id}`, params).then(res => {
          if (res.code) {
            this.$message.success(res.message)
            this.$emit('refresh')
            this.closeDialog()
          } else {
            this.$message.error(res.message)
          }
        }).finally(() => {
          this.buttonLoading = false
        })
      }
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>